import React, { useState } from "react";
import { NovoProduto, ProdutoCategoria } from "../types/store";
import { adminStore } from "../stores/AdminStore";

function isValidImageUrl(url: string) {
  return /^https?:\/\/.*\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(url);
}

const getEmptyProduto = (): NovoProduto => ({
  nome: "",
  categoria: ProdutoCategoria.LOJA,
  autores: "",
  preco: 0,
  desconto: 0,
  descricao: "",
  informacaoAdicional: "",
  fotoCapaUrl: "",
  fotoProdutosUrls: [],
  peso: 0,
  altura: 0,
  comprimento: 0,
  largura: 0,
  quantidadeEstoque: 0,
  ativo: true,
});

export const CadastrarProduto: React.FC = () => {
  const [novoProduto, setNovoProduto] =
    useState<NovoProduto>(getEmptyProduto());
  const [fotoProdutoUrl, setFotoProdutoUrl] = useState("");

  const handlePrecoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Remove everything except digits
    const numeric = value.replace(/\D/g, "");
    // Parse to number (cents)
    const number = parseInt(numeric, 10) || 0;

    setNovoProduto((prev) => ({
      ...prev,
      preco: number / 100,
    }));
  };

  const handleDescontoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Remove everything except digits
    const numeric = value.replace(/\D/g, "");
    // Parse to number (cents)
    const number = parseInt(numeric, 10) || 0;

    setNovoProduto((prev) => ({
      ...prev,
      desconto: number / 100,
    }));
  };

  const handleAddFotoProduto = (e: React.FormEvent) => {
    e.preventDefault();
    if (
      fotoProdutoUrl.trim() !== "" &&
      isValidImageUrl(fotoProdutoUrl.trim())
    ) {
      setNovoProduto((prev) => ({
        ...prev,
        fotoProdutosUrls: [...prev.fotoProdutosUrls, fotoProdutoUrl.trim()],
      }));
      setFotoProdutoUrl("");
    }
  };

  const handleRemoveFotoProduto = (idx: number) => {
    setNovoProduto((prev) => ({
      ...prev,
      fotoProdutosUrls: prev.fotoProdutosUrls.filter((_, i) => i !== idx),
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await adminStore.cadastraProduto(novoProduto);
    if (success) {
      alert("Produto cadastrado com sucesso!");
      setNovoProduto(getEmptyProduto());
      setFotoProdutoUrl("");
    } else {
      alert("Erro ao cadastra produto");
    }
  };

  const inputStyle: React.CSSProperties = {
    width: "100%",
    padding: 12,
    fontSize: 18,
    boxSizing: "border-box",
  };

  const selectStyle: React.CSSProperties = {
    width: "100%",
    padding: 12,
    fontSize: 18,
    boxSizing: "border-box",
    backgroundColor: "#fff",
    color: "#212529",
  };

  // Integers only for Peso, Altura, Comprimento, Largura, Quantidade em Estoque
  const handleIntegerChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: keyof NovoProduto
  ) => {
    const value = e.target.value.replace(/\D/g, "");
    setNovoProduto((prev) => ({
      ...prev,
      [field]: value === "" ? 0 : parseInt(value, 10),
    }));
  };

  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          padding: 32,
          borderRadius: 10,
          width: "100%",
          maxWidth: 600,
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: 24 }}>
          Cadastrar Produto
        </h2>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              marginBottom: 16,
              display: "flex",
              alignItems: "flex-end",
              gap: 16,
            }}
          >
            <div style={{ flex: 1 }}>
              <label style={{ display: "block" }}>
                Nome:
                <br />
                <input
                  id="nome"
                  type="text"
                  value={novoProduto.nome}
                  onChange={(e) =>
                    setNovoProduto((prev) => ({
                      ...prev,
                      nome: e.target.value,
                    }))
                  }
                  style={inputStyle}
                  required
                />
              </label>
            </div>
          </div>
          <div
            style={{
              marginBottom: 16,
              display: "flex",
              alignItems: "flex-end",
              gap: 16,
            }}
          >
            <div style={{ flex: 1 }}>
              <label style={{ display: "block" }}>
                Imagem capa url:
                <br />
                <input
                  id="imagemCapa"
                  type="text"
                  value={novoProduto.fotoCapaUrl}
                  onChange={(e) =>
                    setNovoProduto((prev) => ({
                      ...prev,
                      fotoCapaUrl: e.target.value,
                    }))
                  }
                  style={inputStyle}
                  placeholder="URL da imagem de capa"
                  required
                />
              </label>
            </div>
            {isValidImageUrl(novoProduto.fotoCapaUrl) && (
              <div
                style={{
                  width: 64,
                  height: 64,
                  border: "1px solid #eee",
                  borderRadius: 6,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={novoProduto.fotoCapaUrl}
                  alt="Preview"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              </div>
            )}
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Descrição:
              <br />
              <textarea
                id="descricao"
                value={novoProduto.descricao}
                onChange={(e) =>
                  setNovoProduto((prev) => ({
                    ...prev,
                    descricao: e.target.value,
                  }))
                }
                style={{ ...inputStyle, resize: "vertical" }}
                rows={4}
                required
              />
            </label>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Categoria:
              <br />
              <select
                value={novoProduto.categoria}
                onChange={(e) =>
                  setNovoProduto((prev) => ({
                    ...prev,
                    categoria: parseInt(e.target.value) as ProdutoCategoria,
                  }))
                }
                style={selectStyle}
              >
                <option value={ProdutoCategoria.LOJA}>LOJA</option>
                <option value={ProdutoCategoria.CATALOGO}>CATALOGO</option>
              </select>
            </label>
          </div>

          {/* Campos extras para CATALOGO */}

          <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block" }}>
                Peso (g):
                <br />
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  value={novoProduto.peso}
                  onChange={(e) => handleIntegerChange(e, "peso")}
                  style={inputStyle}
                  required
                />
              </label>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block" }}>
                Altura (cm):
                <br />
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  value={novoProduto.altura}
                  onChange={(e) => handleIntegerChange(e, "altura")}
                  style={inputStyle}
                  required
                />
              </label>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block" }}>
                Comprimento (cm):
                <br />
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  value={novoProduto.comprimento}
                  onChange={(e) => handleIntegerChange(e, "comprimento")}
                  style={inputStyle}
                  required
                />
              </label>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block" }}>
                Largura (cm):
                <br />
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  value={novoProduto.largura}
                  onChange={(e) => handleIntegerChange(e, "largura")}
                  style={inputStyle}
                  required
                />
              </label>
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Preço:
              <br />
              <input
                id="preco"
                type="text"
                value={novoProduto.preco.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
                onChange={handlePrecoChange}
                style={inputStyle}
                inputMode="decimal"
                required
              />
            </label>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Desconto:
              <br />
              <input
                id="desconto"
                type="text"
                value={novoProduto.desconto.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
                onChange={handleDescontoChange}
                style={inputStyle}
                inputMode="decimal"
              />
            </label>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Informações Adicionais:
              <br />
              <textarea
                id="extraInfo"
                value={novoProduto.informacaoAdicional}
                onChange={(e) =>
                  setNovoProduto((prev) => ({
                    ...prev,
                    informacaoAdicional: e.target.value,
                  }))
                }
                style={{ ...inputStyle, resize: "vertical" }}
                rows={3}
              />
            </label>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Autores:
              <br />
              <input
                id="autores"
                type="text"
                value={novoProduto.autores}
                onChange={(e) =>
                  setNovoProduto((prev) => ({
                    ...prev,
                    autores: e.target.value,
                  }))
                }
                style={inputStyle}
              />
            </label>
          </div>
          {/* Campo para adicionar múltiplas fotos do produto */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Fotos do produto url:
              <br />
              <div style={{ display: "flex", gap: 8 }}>
                <input
                  type="text"
                  value={fotoProdutoUrl}
                  onChange={(e) => setFotoProdutoUrl(e.target.value)}
                  style={{ ...inputStyle, marginBottom: 0 }}
                  placeholder="URL da foto do produto"
                />
                <button
                  type="button"
                  onClick={handleAddFotoProduto}
                  style={{
                    padding: "0 16px",
                    fontSize: 22,
                    fontWeight: "bold",
                    background: "#198754",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer",
                  }}
                  title="Adicionar foto"
                  disabled={!isValidImageUrl(fotoProdutoUrl)}
                >
                  +
                </button>
              </div>
            </label>
            {/* Lista de fotos adicionadas */}
            {novoProduto.fotoProdutosUrls.length > 0 && (
              <ul style={{ marginTop: 8, paddingLeft: 0, listStyle: "none" }}>
                {novoProduto.fotoProdutosUrls.map((url, idx) => (
                  <li
                    key={idx}
                    style={{
                      marginBottom: 8,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <div
                      style={{
                        width: 48,
                        height: 48,
                        border: "1px solid #eee",
                        borderRadius: 6,
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#fafafa",
                      }}
                    >
                      <img
                        src={url}
                        alt={`Foto ${idx + 1}`}
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={() => handleRemoveFotoProduto(idx)}
                      style={{
                        background: "#dc3545",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: 16,
                        width: 28,
                        height: 28,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Remover"
                    >
                      x
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block" }}>
              Quantidade em Estoque:
              <br />
              <input
                id="qtdEstoque"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={novoProduto.quantidadeEstoque}
                onChange={(e) => handleIntegerChange(e, "quantidadeEstoque")}
                style={inputStyle}
                required
              />
            </label>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                type="checkbox"
                checked={novoProduto.ativo}
                onChange={(e) =>
                  setNovoProduto((prev) => ({
                    ...prev,
                    ativo: e.target.checked,
                  }))
                }
                style={{ width: 20, height: 20 }}
              />
              Produto ativo
            </label>
          </div>
          <button
            type="submit"
            style={{
              width: "100%",
              padding: 14,
              fontSize: 18,
              fontWeight: "bold",
              background: "#198754",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(25,135,84,0.08)",
              letterSpacing: 1,
              marginTop: 8,
              transition: "background 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = "#157347")}
            onMouseOut={(e) => (e.currentTarget.style.background = "#198754")}
          >
            Cadastrar
          </button>
        </form>
      </div>
    </div>
  );
};
